import React, { useState } from "react";

interface Props {
  loading: boolean;
  setDocuments: (value: any) => void;
}

function LinkDokumenta({ loading, setDocuments }: Props) {
  const [showButton, setShowButton] = useState(true);
  const [link, setLink] = useState("");
  const [linkError, setLinkError] = useState("");

  const onClickAddLink = () => {
    setShowButton(false);
  };

  const dodajDokumentSaLinkom = () => {
    if (!link.match(/^https:\/\/.+/)) {
      setLinkError("Molimo unesite ispravan link.");
      return;
    }
    const document = {
      name: link,
      display_name: `Dokument-${new Date().getTime()}`,
      file_name: link,
      order: null,
      original_name: link,
      link: link,
    };

    setDocuments((prev: any) => [...prev, document]);
    setShowButton(true);
    setLink("");
    setLinkError("");
  };

  const onClose = () => {
    setShowButton(true);
    setLink("");
    setLinkError("");
  };

  return (
    <div>
      {showButton ? (
        <button
          onClick={onClickAddLink}
          disabled={loading}
          className="btn btn-primary"
        >
          Dodaj link dokumenta
        </button>
      ) : (
        <div className="document">
          <div className="thumbInner linkInput w-100">
            <div className="w-100">
              <input
                className="form-control w-100"
                type="url"
                value={link}
                onChange={(e: any) => {
                  setLink(e.target.value);
                }}
              />
              {linkError && (
                <div className="form-error-message text-start">{linkError}</div>
              )}
            </div>
          </div>
          <div className="d-flex align-items-center">
            <button
              disabled={!link}
              onClick={dodajDokumentSaLinkom}
              className="btn btn-primary"
            >
              Dodaj
            </button>
            <div onClick={onClose} className="remove-image">
              <p>X</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default LinkDokumenta;
